
import NoteForm from './components/NoteForm';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import Login from './components/Login';
import Register from './components/Register';
import LandingPage from './components/LandingPage';
import ProtectedRoute from './components/ProtectedRoute';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { CategoryProvider } from './contexts/CategoryContext';
import NoteView from './components/NoteView';
import Dashboard from './components/Dashboard';
import './App.css';
import BoxedLayout from './layouts/PublicLayout';
import DashboardLayout from './layouts/DashboardLayout';

import {ALL_NOTES} from "./utils/constants";

const queryClient = new QueryClient({  
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // disable automatic refetch on window focus
      retry: 1, // retry failed queries once
    },
  },
});

function App() {
  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
            <Navigation selectedCategoryId={ALL_NOTES.id} />
            <Routes>
              {/* Public routes */}
              <Route element={<BoxedLayout />}>
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
              </Route>

              {/* Protected routes */}
              <Route element={<ProtectedRoute />}>
                <Route element={<DashboardLayout />}>
                  <Route path="/notes" element={
                    <CategoryProvider>
                      <Dashboard />
                    </CategoryProvider>
                  } />
                </Route>
                <Route element={<BoxedLayout />}>
                  <Route path="/notes/new" element={
                      <NoteForm />
                  } />
                  <Route path="/notes/:id/view" element={
                      <NoteView />
                  } />
                  <Route path="/notes/:id/edit" element={
                      <NoteForm />
                  } />
                </Route>                
              </Route>

              {/* Redirect to home for unknown routes */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </div>
        </AuthProvider>
      </QueryClientProvider>
    </Router>
  );
}

export default App;
